module.exports = __webpack_public_path__ + "img/login-v2-dark.7adf9f35.svg";